export const CODIGOS_PERMISOS = {
  // Sistema
  ACCEDER_SISTEMA: 'acceder_sistema',
  
  // Documentos - Consulta
  CONSULTAR_DOCUMENTOS: 'consultar_documentos',
  CONSULTAR_DOCUMENTOS_PROPIOS: 'consultar_documentos_propios',
  CONSULTAR_DOCUMENTOS_GRUPO: 'consultar_documentos_grupo',
  CONSULTAR_DOCUMENTOS_LOCAL: 'consultar_documentos_local',
  CONSULTAR_TODOS_DOCUMENTOS: 'consultar_todos_documentos',
  EXPORTAR_DOCUMENTOS: 'exportar_documentos',
  
  // Documentos - Registro
  REGISTRAR_INGRESOS: 'registrar_ingresos',
  REGISTRAR_GASTOS: 'registrar_gastos',
  
  // Documentos - Anulación
  ANULAR_DOCUMENTOS: 'anular_documentos',
  
  // Usuarios
  VER_USUARIOS: 'ver_usuarios',
  CREAR_USUARIOS: 'crear_usuarios',
  EDITAR_USUARIOS: 'editar_usuarios',
  ELIMINAR_USUARIOS: 'eliminar_usuarios',
  ASIGNAR_ROLES: 'asignar_roles',
  
  // Roles
  VER_ROLES: 'ver_roles',
  CREAR_ROLES: 'crear_roles',
  EDITAR_ROLES: 'editar_roles',
  ELIMINAR_ROLES: 'eliminar_roles',
  
  // Configuración
  VER_CONFIGURACION: 'ver_configuracion',
  EDITAR_CONFIGURACION: 'editar_configuracion'
};

// Función para verificar si el usuario tiene un permiso específico
export const tienePermiso = (usuario, codigoPermiso) => {
  if (!usuario || !usuario.rol || !usuario.rol.permisos) {
    return false;
  }
  
  return usuario.rol.permisos.some(permiso => permiso.codigo === codigoPermiso);
};

// Función para verificar si el usuario tiene al menos uno de los permisos
export const tieneAlgunoDeEstosPermisos = (usuario, codigosPermisos) => {
  if (!usuario || !usuario.rol || !usuario.rol.permisos) {
    return false;
  }
  
  return codigosPermisos.some(codigo => 
    usuario.rol.permisos.some(permiso => permiso.codigo === codigo)
  );
};

// Función para verificar si el usuario tiene todos los permisos
export const tieneTodosLosPermisos = (usuario, codigosPermisos) => {
  if (!usuario || !usuario.rol || !usuario.rol.permisos) {
    return false;
  }
  
  return codigosPermisos.every(codigo => 
    usuario.rol.permisos.some(permiso => permiso.codigo === codigo)
  );
};

// Función para obtener el nivel del rol del usuario
export const getNivelRol = (usuario) => {
  if (!usuario || !usuario.rol) {
    return 0;
  }
  return usuario.rol.nivel || 0;
};

// Obtener todos los códigos de permisos del usuario
export const getPermisosUsuario = (usuario) => {
  if (!usuario || !usuario.rol || !usuario.rol.permisos) {
    return [];
  }
  return usuario.rol.permisos.map(p => p.codigo);
};